import request from '@/utils/request'

export const getTimeSlotsByDid = (did) => {
  // 只取今天到未来两周内的时段
  const today = new Date()
  const start = today.toISOString().split('T')[0] // 提取日期部分
  const end = new Date(today.getTime() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  return request.get('/timeslot/available', {
    params: {
      device_id: did,
      start_date: start,
      end_date: end
    }
  })
}

export const createAppointment = (data) => {
  return request.post('/apt/appointments', data)
}

export const getAppointmentByid = (id) => {
  return request.get('/apt/appointment/detail', {
    params: {
      appointment_id: id
    }
  })
}

export const startMassage = (obj) => {
  return request.post('/device/start_massage_session', null, {
    params: {
      device_id: obj.device_id,
      appointment_id: obj.appointment_id
    }
  })
}

export const stopMassage = (obj) => {
  return request.post('/device/stop_massage_session', null, {
    params: {
      device_id: obj.device_id,
      appointment_id: obj.appointment_id
    }
  })
}

export const setMassageStrength = (obj) => {
  return request.post('/device/set_massage_strength', null, {
    params: {
      device_id: obj.device_id,
      appointment_id: obj.appointment_id,
      strength: obj.strength
    }
  })
}

export const cancelAppointment = (id) => {
  return request.post('/apt/appointment/cancel', null, {
    params: {
      appointment_id: id
    }
  })
}
